module.exports = __webpack_public_path__ + "static/media/nuxtJS.59fdf8e1.svg";